import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge } from 'react-bootstrap';
import {
  FiBook,
  FiActivity,
  FiShoppingBag,
  FiTruck,
  FiFeather
} from 'react-icons/fi';

const QuickAccessButtons = () => {
  const navigate = useNavigate();

  // Quick access locations with icons
  const locations = [
    { name: 'UFU Santa Monica', icon: FiBook, color: '#3B82F6' },
    { name: 'UFU Umuarama', icon: FiBook, color: '#8B5CF6' },
    { name: 'UFU Glória', icon: FiBook, color: '#10B981' },
    { name: 'UMC', icon: FiActivity, color: '#F59E0B' },
    { name: 'HCU', icon: FiActivity, color: '#EF4444' },
    { name: 'Cargill', icon: FiTruck, color: '#6366F1' },
    { name: 'Zona Sul', icon: FiShoppingBag, color: '#EC4899' },
    { name: 'Granja Marileusa', icon: FiFeather, color: '#14B8A6' },
  ];


  const handleQuickAccess = (locationName) => {
    navigate(`/properties?location=${encodeURIComponent(locationName)}&radius=5`);
  };

  return (
    <div className="d-flex flex-nowrap gap-2 justify-content-center pb-2">
      <style>
        {`
          .quick-access-badge {
            transition: all 0.3s ease;
            white-space: nowrap;
            cursor: pointer;
            border: 2px solid transparent;
          }
          .quick-access-badge:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            border-color: currentColor;
          }
          .quick-access-badge:active {
            transform: translateY(0);
          }
        `}
      </style>
      {locations.map((location) => {
        const Icon = location.icon;
        return (
          <Badge
            key={location.name}
            className="quick-access-badge d-flex align-items-center gap-2 px-3 py-2 fs-6"
            style={{
              backgroundColor: location.color,
              color: 'white'
            }}
            onClick={() => handleQuickAccess(location.name)}
          >
            <Icon size={18} />
            <span>{location.name}</span>
          </Badge>
        );
      })}
    </div>
  );
};

export default QuickAccessButtons;
